import { gql } from '@apollo/client';

export default gql`
  mutation cancelSubscriptionMutation($input: CancelSubscriptionInput) {
    cancelSubscription(input: $input) {
      id
      created
      modified
      status
      start
      total
      end
      cancellationReason {
        name
        code
        category
      }
      cancellationNote
      collectionMethod
      currency {
        name
        symbol
      }
      frequency
      products {
        id
        merchantProductId
        sku
        type
        description
        metadata {
          key
          value
        }
        amount
        frequency
        currency {
          name
          symbol
        }
      }
      paymentMethods {
        category
        token
        brand
        issuer_id
        last
        expiration
        billingDetails {
          address
          address2
          locality
          region
          postal
          country
        }
      }
    }
  }
`;
